import { TransProps, useTranslation } from 'react-i18next';

import { BasketSummaryDetails } from '../interfaces';
import { UseBasketSummaryItems } from '../interfaces/hooks';

export const useBasketSummaryItems: (
  basePrice: number, finalPrice: number, deliveryPrice: number, discount?: number, commission?: number
) => UseBasketSummaryItems = (
  basePrice: number, finalPrice: number, deliveryPrice: number, discount?: number, commission?: number
): UseBasketSummaryItems => {
  const { t }: TransProps<never> = useTranslation();

  const basketSummaryItems: BasketSummaryDetails[] = [
    {
      label: t('onarte.ui.useBasketSummaryItems.basePrice'),
      price: basePrice
    },
    {
      label: commission !== undefined
        ? t('onarte.ui.useBasketSummaryItems.commission')
        : '',
      price: commission ?? 0
    },
    {
      label: t('onarte.ui.useBasketSummaryItems.deliveryStartPrice'),
      price: deliveryPrice
    },
    {
      label: discount !== undefined
        ? t('onarte.ui.useBasketSummaryItems.discount')
        : '',
      price: discount ?? 0
    },
    {
      label: t('onarte.ui.useBasketSummaryItems.finalPrice'),
      price: finalPrice
    }
  ];

  return {
    basketSummaryItems
  };
};
